import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GoogleService, ModalService } from 'src/app/services';

@Component({
    selector: 'app-isi',
    templateUrl: './isi.component.html',
    styleUrls: ['./isi.component.scss']
})
export class IsiComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() data;
    @Input() medicine: string;
    @Input() scrollable: boolean;

    constructor(
        private modalSvc: ModalService,
        private googleSvc: GoogleService
    ) { }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        if (document.querySelectorAll('.isi a').length) {
            document.querySelectorAll('.isi a').forEach(el => {
                el.addEventListener('click', this.onLinkClick.bind(this));
            });
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.scrollable.currentValue === false) {
            document.querySelector('.isi').scrollTo(0, 0);
        }
    }

    public onLinkClick(e): void {
        const trackingText = `${this.medicine.toUpperCase()} ISI link: ${e.target.innerHTML}`;

        if (e.target.className === 'isi-link') {
            e.preventDefault();

            this.modalSvc.setActiveModalById(e.target.target, { text: trackingText });
        } else {
            this.googleSvc.sendGAEventById(6, {category: trackingText, label: e.target.href});
            window.open(e.target.href);
        }
    }

    public handleHtml(el): any {
        let ret;

        if (typeof el === 'string') {
            ret = `<p>${el || '&nbsp;'}</p>`;
        } else {
            switch(el.element) {
                case 'ul':
                case 'ol':
                    ret = `<${el.element}>`;
                    for (const child of el.children) {
                        ret += `<li>${child}</li>`
                    }
                    ret += `</${el.element}>`;
                break;

                case 'div':
                    ret = `<div class="${el.class}">`;
                    for (const child of el.children) {
                        ret += this.handleHtml(child);
                    }
                    ret += `</div>`;
                break;

                default:
                    ret = `<${el.element}>${el.text || '&nbsp;'}</${el.element}>`;
            }
        }

        return ret;
    }
}
